import { UserDTO } from 'types/user';
import { WIRTransverseRoles, WIRUser } from 'types/wellGuardian';

export const getIsOnlyReadWIRUser = (users: WIRUser[], user: UserDTO | null) => {
  const findUser = users?.find(item => item.userId === user?.igg);
  const userRole = findUser?.roles || [];
  if (userRole.length === 1 && userRole.includes(WIRTransverseRoles.READ_ONLY_WIR_USER)) {
    return true;
  }

  return false;
};
